<template>
  <div style="height: 380px">
    <video
        ref="videoPlayer"
        :duration="true"
        :poster="poster"
        playsinline
        :data-post-id="dataPostId"
        muted
        :responsive="true"
        class="video-js vjs-fluid  vjs-volume-level  vjs-paused vjs-user-inactive vjs-remaining-time-display" controls height="380"
        preload="none">
      <source :src="$replaceHttps(videoSrc)" type="video/mp4"/>
    </video>
  </div>
</template>

<script>
import videojs from 'video.js';

export default {
  name: "ProductVideoPlayer",
  props: ['videoSrc', 'poster','id','dataPostId'],
  data() {
    return {
      player: null
    }
  },
  mounted() {

    this.player = videojs(this.$refs.videoPlayer, this.options, () => {
      // this.player.log('onPlayerReady', this);
      // window.addEventListener ("touchmove", function (event) { event.preventDefault (); }, {passive: false});

      // this.player.on('touchstart', (e) => { e.preventDefault() },{passive: false});

    });

  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }
}
</script>

